import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../components/HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

const ExportMekhrazeemButton = () => {
  const [mekhrazeem, setMekhrazeem] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  console.log(baseURL);
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getMekhrazeem = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "mekhrazeemdetails/",
          {
            signal: controller.signal,
          }
        );

        if (isMounted) {
          const filteredData = response.data.map((item) => ({
            id: item.id,
            mkh_num: item.mkh_num,
            dep_id: item.department,
            title: item.title,
          }));
          setMekhrazeem(filteredData);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getMekhrazeem();

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  const exportToCSV = () => {
    const csvRows = [];
    // Add CSV header
    csvRows.push(Object.keys(mekhrazeem[0]).join("@"));

    // Add data rows
    mekhrazeem.forEach((item) => {
      const values = Object.values(item).map((value) => `"${value}"`);
      csvRows.push(values.join("@"));
    });

    // Join rows into a single CSV string
    const csvString = csvRows.join("\n");

    // Create a Blob object with the CSV data
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const link = document.createElement("a");
    link.href = url;
    link.download = "data.csv";
    document.body.appendChild(link);
    link.click();

    // Cleanup
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  return (
    <center>
      <br />
      <br />
      <h4 style={{ color: "red" }}>יצוא מכרזים</h4>

      <h5>אתה עומד ליצא את כל המכרזים במערכת לקובץ בפורמט CSV</h5>
      <h5>אם אתה בטוח, נא הקש על הכפתור הבא:</h5>
      <button className="btn btn-danger" onClick={exportToCSV}>
        יצוא לפורמט CSV
      </button>
    </center>
  );
};

export default ExportMekhrazeemButton;
